import React, { Component } from "react";
import Container from "../../../modules/commons/Container";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import FakturJualBengkelDGI from "./DGI/fakturJualBengkelDGI";
import FakturJualBengkelNOS from "./NOS/fakturJualBengkelNOS";
import ErrorAction from "../../../Redux/ErrorRedux";
import { connect } from "react-redux";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import SimpleButton from "../../../modules/commons/SimpleButton";

class FakturJualBengkel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fjbAlert: {
        visible: false,
        title: null,
        content: null,
      },
    };
  }

  handleFjbAlert = (title, content) => {
    this.setState((prev) => ({
      ...prev,
      fjbAlert: {
        ...prev.fjbAlert,
        visible: !prev.fjbAlert.visible,
        title: title,
        content: content,
      },
    }));
  };

  render() {
    const { fjbAlert } = this.state;
    return (
      <React.Fragment>
        <Container>
          <Tabs>
            <TabList>
              <Tab id="button_navigate_dgi">DGI</Tab>
              <Tab id="button_navigate_nos">NOS</Tab>
            </TabList>
            <TabPanel>
              <FakturJualBengkelDGI
                onTriggerFjbAlert={this.handleFjbAlert}
                {...this.props}
              />
            </TabPanel>
            <TabPanel>
              <FakturJualBengkelNOS
                onTriggerFjbAlert={this.handleFjbAlert}
                {...this.props}
              />
            </TabPanel>
          </Tabs>
        </Container>
        {fjbAlert.visible && (
          <SimpleAlert
            title={fjbAlert.title}
            content={fjbAlert.content}
            onClickClose={this.handleAlertInfo}
            visible={fjbAlert.visible}
            additionalButtons={
              <SimpleButton
                id="btn_ok_fjb_alert_info"
                text="OK"
                onClick={this.handleFjbAlert}
              />
            }
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth.user,
  user: state.user.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FakturJualBengkel);
